import Emitter from "./Emitter";

export default class SuspendGame extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EVOLUTION_handler() {
        if (this.gb.evolutionSource) {
            this.gb.evolutionSource.postMessage({
                command: "EVO:STOP_AUTOPLAY"
            }, "*")
        }
    }

    MGS_handler() {
        this.emitGame("StopGamePlay");
    }

    BFG_handler() {
        this.emitGame({ "bf:request_action": "stop_autoplay" });
    }

    _default() {
        this.emitGame({ wpgaction: "doGameSuspend" });
    }
}
